import React from 'react';
import { Table, Button, Input, Space, Typography, message, Popconfirm } from 'antd';
import {
    listVideoTags,
    createVideoTag,
    updateVideoTag,
    deleteVideoTag,
} from '../../api/video';

class VideoTagManager extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tags: [],
            loading: false,
            newTagName: '',
        };
    }

    componentDidMount() {
        if (this.props.open) {
            this.loadTags();
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.open && !prevProps.open) {
            this.loadTags();
        }
    }

    loadTags = async () => {
        this.setState({ loading: true });
        try {
            const list = await listVideoTags();
            this.setState({ tags: list });
        } catch (e) {
            message.error(e.message || '加载标签失败');
        } finally {
            this.setState({ loading: false });
        }
    };

    notifyChanged = () => {
        const { onChanged } = this.props;
        if (typeof onChanged === 'function') {
            onChanged();
        }
    };

    handleCreateTag = async () => {
        const name = this.state.newTagName.trim();
        if (!name) {
            message.warning('请输入标签名称');
            return;
        }
        try {
            await createVideoTag({ tagName: name });
            message.success('标签已创建');
            this.setState({ newTagName: '' });
            await this.loadTags();
            this.notifyChanged();
        } catch (e) {
            message.error(e.message || '创建失败');
        }
    };

    handleUpdateTag = async (record, tagName) => {
        try {
            await updateVideoTag(record.id, { tagName });
            await this.loadTags();
            this.notifyChanged();
        } catch (e) {
            message.error(e.message || '更新失败');
        }
    };

    handleDeleteTag = async (id) => {
        try {
            await deleteVideoTag(id);
            message.success('标签已删除');
            await this.loadTags();
            this.notifyChanged();
        } catch (e) {
            message.error(e.message || '删除失败');
        }
    };

    render() {
        const { tags, loading, newTagName } = this.state;

        return (
            <>
                <Typography.Paragraph type="secondary" style={{ marginBottom: 16 }}>
                    每个视频可添加多个标签，用于描述性关键词（如「高清」「经典」）。
                </Typography.Paragraph>
                <Space.Compact style={{ width: '100%', marginBottom: 16 }}>
                    <Input
                        placeholder="新标签名称"
                        value={newTagName}
                        onChange={(e) => this.setState({ newTagName: e.target.value })}
                        onPressEnter={this.handleCreateTag}
                    />
                    <Button type="primary" onClick={this.handleCreateTag}>
                        添加
                    </Button>
                </Space.Compact>
                <Table
                    size="small"
                    rowKey="id"
                    loading={loading}
                    scroll={{ x: 'max-content' }}
                    dataSource={tags}
                    pagination={false}
                    columns={[
                        { title: 'ID', dataIndex: 'id', width: 60 },
                        {
                            title: '名称',
                            dataIndex: 'tagName',
                            render: (v, row) => (
                                <Input
                                    defaultValue={v}
                                    size="small"
                                    onBlur={(e) => {
                                        const next = e.target.value.trim();
                                        if (next && next !== v) {
                                            this.handleUpdateTag(row, next);
                                        }
                                    }}
                                />
                            ),
                        },
                        {
                            title: '操作',
                            width: 80,
                            render: (_, row) => (
                                <Popconfirm
                                    title="确认删除该标签？"
                                    description="仅当无关联视频时可删除"
                                    onConfirm={() => this.handleDeleteTag(row.id)}
                                >
                                    <Button type="link" size="small" danger>
                                        删除
                                    </Button>
                                </Popconfirm>
                            ),
                        },
                    ]}
                />
            </>
        );
    }
}

export default VideoTagManager;
